import React from "react";
import usePageNavigation from "../uesPageNavigation";
import versionData from "../json/version.json";
import "../assets/sass/versionStyle.scss"; // Assuming you have a CSS module for styles

const VersionPage = () => {
  const { navigateToPage } = usePageNavigation(); // Custom hook to navigate

  return (
    <div className="versionPage">
      {versionData.map((item, index) => (
        <div
          key={index}
          className={`versionItem ${item.active ? "active" : ""}`}
        >
          <div className="versionTitle">Version: {item.version}</div>
          <div className="versionDate">Date: {item.date}</div>
          <div className="versionDescription">Desc: {item.description}</div>
        </div>
      ))}
      <button onClick={() => navigateToPage("/")}>Back to home</button>
    </div>
  );
};

export default VersionPage;
